<div class="events-manager-wrapper"
     [ngClass]="{'hide-event-list': !showEventList}"
     *ngIf="!showNewAddButton || events && events.length > 0; else no_events_to_display">
  <ispm-pan-cancer-events-list
     [selectedEvent]="selectedEvent"
    (onChangeEvent)="changeSelectedEvent($event)"
    (onChangeTogglePanel)="changeTogglePanel($event)"
    (onCreateEvent)="showCreateEventPopup()"
    (onDeleteEvent)="deleteEvent($event)"
     (onSelectEvent)="selectEvent($event)"
     [ngStyle]="showReviewExtraction?{'opacity':'0.5'}:{}"
     [showEventsGroup]="showEventsGroup"
     [config]="config"
     [isEditable]="permitPanCancerEventWrite && isEditable"
     [totalEvents]="events ? events.length: 0"
     [eventCategories]="showEventsGroup ? eventCatAndEvents: events">
  </ispm-pan-cancer-events-list>
 <!-- <div *ngIf="!showReviewExtraction">-->
  <ispm-event-content-viewer
          *ngIf="events && events.length > 0 && !showReviewExtraction"
          [isEditable]="permitPanCancerEventWrite && (isExternal=== false) && isEditable"
          [config]="config"
          [selectedEvent]="selectedEvent"
          [eventSelection]="eventSelection"
          (onChangeDataEvent)="changeDataEvent($event)"
          (onUpdateDataEvent)="changeDataEvent(!$event)"
          [events]="events"
          [showLaunchPacsInEventContent]="showLaunchPacsInEventContent && pacsIntegrationAvailable"
          [eventsDefinitions]="eventsDefinitions">
  </ispm-event-content-viewer>
 <!-- </div>-->
  <gen-button class="event-actions-right-side" *ngIf="events && events.length == 0 && isEditable"
          [text]="'Back To Dashboard'"
          (click)="backToDashBoard()">
  </gen-button>

  <ispm-pacs-launcher class="button-pacs" *ngIf="showLaunchPacsInReportPreview && pacsIntegrationAvailable"
    [currentEvent]="selectedEvent">
  </ispm-pacs-launcher>

</div>
<gen-dynamic-modal-loader class="pan-cancer-event-modal" [observableName]="ModalLoaderTunnelName"></gen-dynamic-modal-loader>
<ng-template #no_events_to_display>
  <section class="add-first-event" *ngIf="permitPanCancerEventWrite && (isExternal === false) && showNewAddButton; else no_data_to_display">
    <div>
        <span class="add-button"
              *ngIf="showAddButton"
              (click)="showCreateEventPopup()">
          <i class="icon__Plus1"></i>
        </span>
    </div>
  </section>
  <ng-template #no_data_to_display>
    <span>{{'NO_EVENTS_TO_DISPLAY' | translate}}</span>
  </ng-template>
</ng-template>
<div *ngIf="showReviewExtraction" class="validation-wizard-wrapper">
  <ispm-nlp-validation-wizard
  [selectedEvent] ="selectedEvent"
  [eventsDefinitions]="eventsDefinitions"
  [reviewExtractionKey]="showReviewExtraction"
  [config]="config">
  </ispm-nlp-validation-wizard>
</div>

